import React from "react"
import { Col, Placeholder, Row } from "reactstrap"
import TimeAgo from "react-timeago"
import VideoVoted from "pages/Home/components/VideoVoted"
import userPlaceHolder from "../../../assets/images/userPlaceHolder.svg"
import { Link } from "react-router-dom"
import personPlaceholder from "assets/images/personPlaceholder.png"
import FloatingHeart from "../../animation/FloatingHeart/FloatingHeart"

const VideoCard = ({ data, imageHeight = 480, showVideoVoted = true }) => {
  const iconSize = imageHeight < 300 ? 32 : 40
  const badgePadding = imageHeight < 300 ? "0.3rem 0.5rem" : "0.5rem 0.75rem"
  return (
    <div>
      <FloatingHeart
        number={data?.likeCount}
        duration={Math.floor(Math.random() * 20) + 5}
      />
      <div className="image-container position-relative">
        <Link to={`/videodetail/${data?._id}`}>
          <img
            src={`${process.env.REACT_APP_S3_BUCKET}${data?.thumbnail}`}
            alt=""
            className="w-100 rounded-4 img-fluid videoCard-thumbnail object-fit-cover"
            style={{
              height: `${imageHeight}px`,
            }}
          />
        </Link>
        <div
          style={{
            maxWidth: "92%",
            zIndex: 12,
            padding: badgePadding,
            height: "auto",
          }}
          className="position-absolute top-0 bg-white rounded-pill ps-2 mt-2 ms-2 icon-container d-flex align-items-center"
        >
          <Link to={`/userprofile/${data?.createdBy?._id}`}>
            <img
              referrerPolicy="no-referrer"
              src={
                data?.createdBy?.additionalInfo?.profileImage
                  ? data?.createdBy?.additionalInfo?.profileImage.includes(
                      "googleusercontent"
                    )
                    ? data?.createdBy?.additionalInfo?.profileImage
                    : process.env.REACT_APP_S3_BUCKET +
                      data?.createdBy?.additionalInfo?.profileImage
                  : personPlaceholder
              }
              alt="icon"
              width={iconSize}
              height={iconSize}
              style={{
                borderRadius: "50px",
                objectFit: "cover",
              }}
            />
          </Link>

          <span className="text-black mx-1 font-size-15 text-uppercase font-weight-500 text-nowrap icon-title">
            <Link to={`/userprofile/${data?.createdBy?._id}`}>
              {data?.createdBy?.firstName} {data?.createdBy?.lastName}
            </Link>
          </span>
        </div>
      </div>
      <div className="mt-2">
        <p className={` font-size-12 text-secondary p-0 m-0 ff-proxima pt-2`}>
          {/* <TimeAgo date={data?.updatedAt} /> */}
          {data?.updatedAt &&
            new Date(data.updatedAt)?.toLocaleDateString("en-US", {
              year: "numeric",
              month: "short",
              day: "numeric",
            })}
        </p>
        <h3
          className={` font-size-18 fw-bolder text-darkcolor ff-proxima `}
          style={{
            textWrap: "nowrap",
          }}
        >
          <Link to={`/videodetail/${data?._id}`} className="ff-proxima">
            {data?.title?.length > 20
              ? `${data.title.slice(0, 20)}...`
              : data?.title}
          </Link>
        </h3>
      </div>

      {showVideoVoted && (
        <VideoVoted
          videoId={data?._id}
          isLiked={data?.isLiked}
          userVoteType={data?.userVoteType}
          voteTypes={data?.voteTypes}
          likeCount={data?.likeCount}
        />
      )}
    </div>
  )
}

export default VideoCard
